import * as signalR from "@microsoft/signalr";
import { SIGNALR_URL } from "./configs/api"; // Adjust path if needed

export const getSignalRConnection = (userId) => {
  if (!userId) return null;

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${SIGNALR_URL}?userId=${userId}`)
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connection
    .start()
    .then(async() =>

      // Automatically invoke "SendOnlineUsers" once connected
      await connection.invoke("SendOnlineUsers"),

      // start connection console
      console.log("SignalR Connection Started")
  )
    .catch((err) => console.error("Error starting SignalR:", err));

  return connection;
};


